import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import FilterResponse, {
  FilterResponseV2,
} from "../../_helpers/FilterResponse";
const version_type = 1;
const parentObject = 1;
const callApi = async (api, Method, data, vtype, pObject) => {
  try {
    const response = await RestMethod[Method](api, data);
    if (version_type === vtype) {
      const api_response = FilterResponse(response); //If respone 200 to 299 Then return
      return api_response.data;
    } else {
      const api_response = FilterResponseV2(response); //If respone 200 to 299 Then return
      return api_response.data[0] ? api_response.data[0] : api_response.data;
    }
  } catch (error) {
    // toastr.error('Something Went Wrong')
    console.log("error detected while fetching data from api");
    return null;
  }
};

// export const getBankerTokensHeaderData = (queryParam, offset, limit) => {
//   var reuestlink = `/blockchain/depositor/verify-tokens?${
//     limit ? "&offset=" + offset : ""
//   }${limit ? "&limit=" + limit : ""}${queryParam ? queryParam : ""}`;
//   return callApi(reuestlink, "GET");
// };

export const getBankerViewTokensData = (queryParam, offset, limit) => {
  var reuestlink = `/blockchain/banker/view-tokens?${
    limit ? "offset=" + offset : ""
  }${limit ? "&limit=" + limit : ""}${queryParam ? queryParam : ""}`;
  return callApi(reuestlink, "GET");
};

export const getBankerViewTokensDataPublic = (queryParam, offset, limit) => {
  var reuestlink = `/blockchain/v1/view-tokens?${
    limit ? "offset=" + offset : ""
  }${limit ? "&limit=" + limit : ""}${queryParam ? queryParam : ""}`;
  return callApi(reuestlink, "GET");
};

export const getBankerLoanRequestData = (queryParam, offset, limit) => {
  var reuestlink = `/blockchain/banker/loan-request?${
    limit ? "offset=" + offset : ""
  }${limit ? "&limit=" + limit : ""}${queryParam ? queryParam : ""}`;
  return callApi(reuestlink, "GET");
};

export const getBankerOfferMadeData = (queryParam, offset, limit) => {
  var reuestlink = `/blockchain/banker/offers-made?${
    limit ? "offset=" + offset : ""
  }${limit ? "&limit=" + limit : ""}${queryParam ? queryParam : ""}`;
  return callApi(reuestlink, "GET");
};

export const getBankerCustomizeFilterTemplateData = (
  queryParam,
  offset,
  limit
) => {
  var reuestlink = `/blockchain/banker/customized-filter-template?${
    limit ? "&offset=" + offset : ""
  }${limit ? "&limit=" + limit : ""}${queryParam ? queryParam : ""}`;
  return callApi(reuestlink, "GET");
};

export const makeLoanOfferApi = (data) => {
  var reuestlink = `/blockchain/banker/update-offers`;
  return callApi(reuestlink, "POST", data, null, parentObject);
};

export const getMadeOfferDetails = (stack) => {
  var reuestlink = `/blockchain/banker/offer-made-individual/${stack}`;
  return callApi(reuestlink, "GET");
};

export const getStackIdByData = (data) => {
  var reuestlink = `/blockchain/depositor/get-stack-id`;
  return callApi(reuestlink, "POST", data);
};

export const makeLoanOfferApiByToken = (data) => {
  var reuestlink = `/blockchain/banker/make-offer`;
  return callApi(reuestlink, "POST", data, null, parentObject);
};

export const totalLoanRequest = () => {
  var reuestlink = `/blockchain/banker/total-loan-request`;
  return callApi(reuestlink, "GET");
};

export const checkLoanOffer = (data) => {
  var reuestlink = `/blockchain/v1/check-offer`;
  return callApi(reuestlink, "POST", data, null, parentObject);
};
